/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Usb = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 22 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M20.77 11.67a4 4 0 0 0-5.68 0l-9 9a2.828 2.828 0 1 1-4-4l1.8-1.8.2-.2a3.94 3.94 0 0 0 5 .21.71.71 0 0 0 .18-.12l5-5.05a.72.72 0 0 0 .13-.75l3.84-3.84L13.78.64 10 4.41l-.09-.09a.8.8 0 0 0-1.11-.08L4.37 8.7 4 9a4 4 0 0 0-.65 4.76l-.35.32-1.77 1.81a4.013 4.013 0 1 0 5.68 5.67l9-9a2.828 2.828 0 1 1 4 4l-7.83 7.84a.61.61 0 0 0 0 .85.6.6 0 0 0 .43.18.58.58 0 0 0 .42-.18l7.84-7.83a4 4 0 0 0 0-5.75zm-7-10l3.49 3.48L14 8.42 12.1 6.5l-1.55-1.56 3.22-3.27z" fillRule="nonzero" />
      </g>
    </svg>
  </span>
);

Usb.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Usb.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Usb;
